import { DEVELOPMENT_PORTS } from "./constants";
export const isTestEnvironment = (): boolean => {
  return (
    typeof process !== "undefined" &&
    (process.env?.NODE_ENV === "test" ||
      process.env?.JASMINE === "true" ||
      typeof (globalThis as any).jasmine !== "undefined" ||
      typeof (globalThis as any).jest !== "undefined" ||
      typeof (globalThis as any).mocha !== "undefined")
  );
};
export const isDevelopmentEnvironment = (): boolean => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return true;
    }
    const port = window.location.port;
    if (port && DEVELOPMENT_PORTS.has(port)) {
      return true;
    }
    if (window.location.protocol === "https:" && hostname === "localhost") {
      return true;
    }
  }
  if (typeof process !== "undefined") {
    if (process.env?.NODE_ENV === "development") {
      return true;
    }
  }
  return false;
};
export const isNonProductionEnvironment = (): boolean => {
  return isTestEnvironment() || isDevelopmentEnvironment();
};
export const isProductionEnvironment = (): boolean => {
  return !isNonProductionEnvironment();
};
export const getBaseUrl = (): string => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost";
};
